export const MAX_ATTACHMENT_COUNT = 100;
